import { render, staticRenderFns } from "./OrganisationSettings.vue?vue&type=template&id=58b6ce5b&scoped=true&"
import script from "./OrganisationSettings.vue?vue&type=script&lang=js&"
export * from "./OrganisationSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationSettings.vue?vue&type=style&index=0&id=58b6ce5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6ce5b",
  null
  
)

export default component.exports